import React, { useState } from 'react';
import VPaNettbutikkCSS from './vpAdminNettbutikk.module.css';
import useRetrieveProductsGraphQL from '../../../../hooks/products';
import Loader from '../../../loader';
import CustomAlert from '../../../customAlert';
import VpAdminProductCard from '../../../VP/productCards';
import AddProductForm from '../../../VP/addProduct';
import FormModal from '../../../formModal';
import { filterObjects } from '../../../../helpers/searchFunctionality';
import HandleSuppliersForm from '../../../VP/addSupplier';
import AddCategories from '../../../VP/addCategory';
import AddConsumableForm from '../../../VP/addConsumableProduct';

export function VPadminNettbutikk() {

    const {products, isLoading, isError} = useRetrieveProductsGraphQL();
    const [searchText, setSearchText] = useState('');

    const visibleProducts = products.filter(product => product.attributes.visible === true);
    const hiddenProducts = products.filter(product => product.attributes.visible === false);

    const handleSearchInputChange = (e) => {
        setSearchText(e.target.value);
    };

    if(isLoading || !products) {
        return <div>
            <Loader />
        </div>
    }
    if(isError) {
        <CustomAlert 
            message="Oida, her gikk noe galt!"
        />
    }

    const filteredVisibleProducts = filterObjects(searchText, visibleProducts);
    const filteredHiddenProducts = filterObjects(searchText, hiddenProducts);

    return(
        <div>
            <h1>ALLE PRODUKTER</h1>
            <input 
                type="text"
                placeholder='Søk...'
                value={searchText}
                onChange={handleSearchInputChange}
                className='search-bar'
            />
            <div className={VPaNettbutikkCSS.container1}>
                <div className={VPaNettbutikkCSS.container2}>
                    <div className={VPaNettbutikkCSS.subContainer1}>
                        <FormModal 
                            buttonTitle="Legg til produkt"
                            body={<AddProductForm />}
                            modalTitle="Legg til produkt"
                            openButtonClass={VPaNettbutikkCSS.openButton}
                            closeButtonClass={VPaNettbutikkCSS.closeButton}
                        />
                    </div>
                    <div className={`${VPaNettbutikkCSS.subContainer1} mt-4`}>
                        <FormModal 
                            buttonTitle="Legg til forbruksvarer"
                            body={<AddConsumableForm />}
                            modalTitle="Legg til forbruksvarer"
                            openButtonClass={VPaNettbutikkCSS.openButton}
                            closeButtonClass={VPaNettbutikkCSS.closeButton}
                        />
                    </div>
                    <div className={`${VPaNettbutikkCSS.subContainer1} mt-4`}>
                        <FormModal 
                            buttonTitle="Rediger leverandører"
                            body={<HandleSuppliersForm />}
                            modalTitle="Rediger leverandør"
                            openButtonClass={VPaNettbutikkCSS.openButton}
                            closeButtonClass={VPaNettbutikkCSS.closeButton}
                        />
                    </div>
                    <div className={`${VPaNettbutikkCSS.subContainer1} mt-4`}>
                        <FormModal 
                            buttonTitle="Rediger kategorier"
                            body={<AddCategories />}
                            modalTitle="Rediger kategorier"
                            openButtonClass={VPaNettbutikkCSS.openButton}
                            closeButtonClass={VPaNettbutikkCSS.closeButton}
                        />
                    </div>
                </div>
                <div className={VPaNettbutikkCSS.container3}>
                    <div className={VPaNettbutikkCSS.container4}>
                        {filteredVisibleProducts.map((product) => (
                            <div key={product.id} className={VPaNettbutikkCSS.cardContainer}>
                                <VpAdminProductCard key={product.id} product={product} />
                            </div>
                        ))}
                    </div>
                    <div className={VPaNettbutikkCSS.container4}>
                            <div className={VPaNettbutikkCSS.container5}>
                                <h3 className="mb-3">Skjult fra nettbutikken</h3>
                            </div>
                        {filteredHiddenProducts.map((product) => (
                            <div key={product.id} className={VPaNettbutikkCSS.cardContainer}>
                                <VpAdminProductCard key={product.id} product={product} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VPadminNettbutikk;